import { render, staticRenderFns } from "./image-with-text-conven-feet-03.vue?vue&type=template&id=64f5005c&scoped=true&"
import script from "./image-with-text-conven-feet-03.vue?vue&type=script&lang=js&"
export * from "./image-with-text-conven-feet-03.vue?vue&type=script&lang=js&"
import style0 from "./image-with-text-conven-feet-03.vue?vue&type=style&index=0&id=64f5005c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f5005c",
  null
  
)

export default component.exports